export default __webpack_public_path__ + "static/media/login_back.caa1ea30.jpg";